import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import getError from '@/containers/SubscriptionFormPageNew/getError'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'

const AdditionalInformation = () => {
  const { t, updateAddress, errors, additionalInformation } = useAddress()
  return (
    <SDFormControl plainLabel error={getError('additionalInformation', errors)}>
      <SDInput
        label={t('subscriptionForm:address_module.additional_information')}
        onBlur={additionalInformation => updateAddress({ additionalInformation })}
        currentValue={additionalInformation}
      />
    </SDFormControl>
  )
}

export default AdditionalInformation
